import { FormControl, FormHelperText, FormLabel } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { COURSE_TRANSLATION_LANGUAGES } from '@duke-hq/shared-constants/courseTranslationLanguages';
import { testIds } from './testIds';

type LanguageOption = { value: string; label: string };

const LANGUAGE_OPTIONS: LanguageOption[] = COURSE_TRANSLATION_LANGUAGES.map((language) => ({
  value: language.code,
  label: `${language.englishName} (${language.endonym})`,
}));

// The languages a course is translated into. Controlled: the settings form owns
// the selection and persists it on Update, via a separate mutation since the set
// lives in CourseTranslationConfig. Saving records intent only; publish generates.
export function CourseLanguagesField({
  value,
  onChange,
  isLoading,
}: {
  value: string[];
  onChange: (languages: string[]) => void;
  isLoading?: boolean;
}) {
  return (
    <FormControl>
      <FormLabel htmlFor="course-languages">
        <Trans>Translation languages</Trans>
      </FormLabel>
      <Select
        isMulti
        inputId="course-languages"
        data-testid={testIds.select}
        isLoading={isLoading}
        placeholder={t`Select languages`}
        options={LANGUAGE_OPTIONS}
        value={LANGUAGE_OPTIONS.filter((option) => value.includes(option.value))}
        onChange={(options) => onChange(options.map((option) => option.value))}
        maxMenuHeight={220}
        selectedOptionColorScheme="brand"
        useBasicStyles
        // Render the menu in a portal so it isn't clipped by the settings
        // drawer's overflow; the z-index keeps it above the drawer.
        menuPortalTarget={typeof document === 'undefined' ? undefined : document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 1500 }) }}
      />
      <FormHelperText>
        <Trans>
          Published resources in this course are translated into these languages. Removing a
          language stops new translations but keeps existing ones.
        </Trans>
      </FormHelperText>
    </FormControl>
  );
}
